import { useFieldArray, useFormContext } from 'react-hook-form';
import { InputField } from 'lib/iterable-hook-form';
import { Caption } from 'ui/theme';
import { GhostSuccessButton, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { FormField, ErrorText } from 'ui/formField';
import { Add16, Close16 } from 'ui/icons';
import { KeyValuePairRow, LightText, HeightAlignedIconButton } from './CustomHeadersFields.styled';
import { getFieldErrorObject } from './CustomHeadersFields.utils';

export const CustomHeadersFields = ({ name }: { name: string }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const add = () => {
    append({ key: '', value: '' });
  };

  const createRemove = (idx: number) => () => {
    remove(idx);
  };

  return (
    <FormField
      labelText={
        <>
          Custom headers <LightText>&nbsp;&nbsp;(optional)</LightText>
        </>
      }
      descriptionText="Some endpoints require specific HTTP headers with each incoming request."
    >
      {fields.length > 0 && (
        <KeyValuePairRow>
          <Caption>Name</Caption>
          <Caption>Value</Caption>
        </KeyValuePairRow>
      )}
      {fields.map((field, idx: number) => {
        const getKey = getFieldErrorObject(errors, name);
        const fieldError = getKey?.[idx as keyof (typeof errors)[typeof name]] as any;
        return (
          <KeyValuePairRow key={field.id} data-test={`custom-header-row-${idx}`}>
            <div>
              <InputField
                data-test={`custom-header-key-input-${idx}`}
                name={`${name}.${idx}.key`}
              />
              {fieldError?.key?.message && <ErrorText>{fieldError?.key?.message}</ErrorText>}
            </div>
            <div>
              <InputField
                data-test={`custom-header-value-input-${idx}`}
                name={`${name}.${idx}.value`}
              />
              {fieldError?.value?.message && <ErrorText>{fieldError?.value?.message}</ErrorText>}
            </div>
            <HeightAlignedIconButton
              data-test={`remove-header-button-${idx}`}
              onClick={createRemove(idx)}
              variant={BUTTON_VARIANTS.GHOST}
            >
              <Close16 />
            </HeightAlignedIconButton>
          </KeyValuePairRow>
        );
      })}
      <GhostSuccessButton onClick={add} size={BUTTON_SIZES.LARGE}>
        <Add16 />
        Add header
      </GhostSuccessButton>
    </FormField>
  );
};
